module.exports = __webpack_public_path__ + "static/img/锁.6356cc8c.svg";